import React, { Component } from "react"
import PropTypes from "prop-types"
import ThankYouMessage from "./ThankYouMessage"

class TradeInThankYou extends Component {
  render() {
    const {
      displayValuation,
      thankYouTextWhenValuated,
      thankYouTextWhenNoValuation,
      thankYouAdditionalText,
      removeThankYouCheckmark,
      contactQualificationSent,
      thankYouWhenContactQualification,
    } = this.props

    const text = contactQualificationSent
      ? thankYouWhenContactQualification
      : displayValuation
      ? thankYouTextWhenValuated
      : thankYouTextWhenNoValuation

    return (
      <ThankYouMessage
        text={text}
        additionalText={thankYouAdditionalText}
        removeThankYouCheckmark={removeThankYouCheckmark}
      />
    )
  }
}

TradeInThankYou.propTypes = {
  displayValuation: PropTypes.bool,
  thankYouTextWhenValuated: PropTypes.string,
  thankYouTextWhenNoValuation: PropTypes.string,
  thankYouAdditionalText: PropTypes.string,
  removeThankYouCheckmark: PropTypes.bool,
  contactQualificationSent: PropTypes.bool,
  thankYouWhenContactQualification: PropTypes.string,
}

export default TradeInThankYou
